import "./PhotoContainer.scss";
import profile from "../assets/images/profile-ellipse.jpg";


export const PhotoContainer = () => {
  return (
    <div className='photo-container'>
      <img className='photo-container__image' src={ profile } alt='profile photo' />
    </div>
  )
};